export default __webpack_public_path__ + "static/media/HL_Mathematics_AA.e3a2de24.svg";